<template>
  <div class="overflow-hidden rounded">
    <QrcodeStream
      @detect="onDetect"
      @camera-on="loading = false"
      @error="onError"
      :constraints="{ zoom: 1.0, facingMode: 'environment' }"
    >
      <div v-if="gotError">
        <p class="font-rubik mb-4 font-normal leading-[24px] text-primary">
          {{ $t('QrCodeReader.errorToast') }}
        </p>
      </div>
      <div v-if="loading && !gotError" class="flex h-full items-center justify-center">
        <IconLoader2 stroke="1.5" class="left-6 h-8 w-8 animate-spin text-primary" />
      </div>
    </QrcodeStream>
  </div>
</template>

<script lang="ts" setup>
import { showDefaultToast } from '@helpers/toast-models'
import { IconLoader2 } from '@tabler/icons-vue'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { QrcodeStream } from 'vue-qrcode-reader'
import type { OnDetectedOptions } from './types'

const emit = defineEmits(['onDetect'])
const loading = ref(true)
const gotError = ref(false)

const { t } = useI18n()

const onDetect = (detectedCodes: OnDetectedOptions[]) => {
  emit('onDetect', detectedCodes[0].rawValue)
}

const onError = () => {
  showDefaultToast(t('QrCodeReader.errorToast'), "error", 400);

  gotError.value = true
}
</script>
